export default "__VITE_ASSET__68pmaax0__"